/**
 * Eight Queens chess game
 * Did You Know
 */

const didYouKnow = [
    "",
    // following tidbits modified from <https://en.wikipedia.org/wiki/Eight_queens_puzzle>
    // License: Creative Commons Attribution-ShareAlike License
    "The eight queens puzzle is an example of the n queens problem of placing n non-attacking queens on an n×n chessboard.",
    "Chess composer Max Bezzel published the original eight queens puzzle in 1848.",
    "Franz Nauck published a solution to the eight queens puzzle in 1850.",
    "Many mathematicians, including Carl Friedrich Gauss, have worked on the 8 queens puzzle and its generalized n-queens version.",
    "In 1874, S. Gunther proposed a method using determinants to find solutions to the eight queens puzzle.",
    "In 1972, Edsger Dijkstra used the eight queens problem to illustrate the power of structured programming.",
    "The problem of finding all solutions to the 8-queens problem can be computationally expensive.",
    "There are 4,426,165,368 possible arrangements of eight queens on an 8×8 board.",
    "There are 92 solutions to the eight queens problem!",
    "There are only 12 fundamental solutions if you ignore symmetry operations, rotation and reflection",
    "A fundamental solution usually has eight variants.",
    "Finding all solutions to the eight queens puzzle is a good example of a simple but nontrivial problem.",
    "Eight queens is often used as an example problem for programming techniques.",
    "8 queens is often an example problem for constraint programming, logic programming and genetic algorithms.",
    "Eight queens can be solved with a recursive algorithm.",
    "In 1976 Niklaus Wirth wrote a Pascal program to find one solution to the eight queens puzzle",
    // following tidbits modified from <http://csplib.org/Problems/prob054/>
    //   by Bilal Syed Hussain
    // License: Creative Commons Attribution 4.0 International License.
    "The eight queens problem is extremely well studied in the mathematical literature.",
    "In chess a queen attacks other squares on the same row, column, or either diagonal as itself.",
    "The n-queens problem is to find a set of n locations on a chessboard, no two of which are on the same row, column or diagonal.",
    "The eight queens problem has inherent symmetry.",
    "For any solution we obtain another solution by any of the 8 symmetries of the chessboard.",
    "The n-queens problem is solvable for n=1 and n≥4.",
    "A solution to the n-queens problem for any n≠2,3 was given in 1874 by Pauls.",
    "The parameter n for n-queens only needs log(n) bits to specify, so O(n) is exponential in the input size.",
    "The number of symmetrically distinct solutions to the n-queens problem is Sequence number A002562 in the On-Line Encyclopedia of Integer Sequences.",
    "The number of solutions to the n-queens problem is Sequence number A000170 in the On-Line Encyclopedia of Integer Sequences.",
    // following tidbits modified from:
    //   Taheri Sarvetamin M, Khatibi A, Zahedi MA.
    //   A New Approach to Solve N-Queen Problem with Parallel Genetic Algorithm.
    //   J. ADV COMP ENG TECHNOL, 4(2) Spring 2018 : 69-78
    // License: Creative Commons Attribution 4.0 International Licence.
    "The N-Queen problem is a well-known Constraint Satisfaction Problem.",
    "Traditional methods of solving the N-queens problem are based on back-tracking.",
    "The N-Queen problem shows a large class of nondeterministic problems that cannot be solved using deterministic algorithms in reasonable time.",
    "Many algorithms and methods have been used to resolve the n-Queen problem.",
    "Ahrabian et al. used the DNA Sticker algorithm to resolve the n-Queen problem.",
    "Khan et al. used the ant colony algorithm to solve the n-Queen problem.",
    "Farhan et al. used a genetic algorithm to solve this problem and found all 92 possible solutions to the 8-queen problem.",
    "A depth-first search backtracking algorithm may resolve the n-Queens problem in acceptable time, but just for small values of n.",
    "The n-Queen problem can be successfully run with parallel genetic algorithms.",
    "The n-Queens problem is a traditional intractable problem that is used to discuss numerous kinds of searching problems.",
    // following tidbits modified from <https://upjoke.com/chess-jokes>
    // License: acquiescence
    "If you forget the rules of Chess don't worry... you're allowed to check.",
    "So the other day in the lobby I hear two chess masters bragging about their past wins.  They were chess nuts boasting in an open foyer.",
    "I went to lunch with a champion chess player.  It took them 8 minutes to pass me the salt.",
    "Finally got a job making chess pieces.  I start on nights next week.",
    "A computer beat me at chess.  But I really got the better of it in boxing.",
    "Why shouldn't you eat a chess sandwich?  It's stale, mate.",
    "Why did the chess player throw away his bread?  Because it was stalemate.",
    // following tidbits from EightQueens contributors
    // License: MIT License
    "Hint: how does a knight move?",
    "Is this a chess puzzle, a chess problem, or a chess game?",
    "Of the 92 possible solutions, there are 12 fundamental solutions.",
    "How to programmatically solve the 8 Queens problem is often used as a test during programmer interviews.",
    "How to programmatically solve the 8 Queens problem is often used as an assignment in computer science classes.",
    "Mathematicians love eight queens.",
    "Help, I'm stuck inside an interactive, virtualized, modularized cloud-based chess game!",
];

export default didYouKnow;
